import React, {useContext} from 'react';
import {Context} from '../AppContext';
import Login, {metadata} from '../Modals/Login';
import {navigate} from 'gatsby';

export default function useAuth() {
  const app = useContext(Context);

  const isBrowser = typeof window !== 'undefined';

  let token;
  if (isBrowser) {
    token = window.localStorage.getItem('token');
  }

  const isLogin = () => !!token;

  const handleUnauthenticated = () => {
    if (!isLogin()) {
      navigate('/');
    }
  };

  const handleUnauthenticatedWithLoginModal = (page = '/orders') => {
    if (isLogin()) {
      navigate(page);
    } else {
      app.actions.setModal({
        content: <Login />,
        ...metadata,
      });
    }
  };

  return {
    handleUnauthenticated,
    handleUnauthenticatedWithLoginModal,
  };
}
